import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { UserData } from '../../Models/Authentication/UserModel';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.css'],
  encapsulation:ViewEncapsulation.Emulated
  ,standalone:false
})
export class BottomNavComponent implements OnInit {
  isDarkTheme: boolean = false;
  userRole!:string
  user1!:UserData
  loading:boolean=false;
  username:string=''
  userId:string=''
  items: MenuItem[] | undefined;
  constructor
  (
    private api: BaseApiService,
    private messageService: MessageService,
    private auth:AuthService,
    private router: Router
  )
  {
    this.userId = this.auth.getUID();
    this.userRole=this.auth.getRoles().toString();
  }

  getClassForRoute(route: string): string {
    const isActive = this.router.isActive(route, true);

    if (isActive) {
      return 'icon bg-blue icon-shape icon-xl rounded-circle smooth-shadow-lg mt-n6 active';
    } else {
      return 'icon';
    }
  }

  GetAll(uid:any){
    this.loading=true;
    this.api.read(`Auth/getByIdDT?uid=${uid}`).subscribe
    (
      (response)=>{
        this.user1 = response;
        this.username = this.username+this.user1.userName
        this.loading=false;
      }
      ,(
        error
      )=>{

        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
   }


   toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    if (this.isDarkTheme) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }

  }

  logOut(){
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  ngOnInit(): void {
    this.items = [
      {
          icon: 'pi pi-pencil',
          style: { background: '#4CAF50', color: 'white' },
          command: () => {
              this.messageService.add({ severity: 'info', summary: 'Add', detail: 'Data Added' });
          }
      },
      {
          icon: 'pi pi-refresh',
          command: () => {
              this.messageService.add({ severity: 'success', summary: 'Update', detail: 'Data Updated' });
          }
      },
      {
          icon: 'pi pi-trash',
          command: () => {
              this.messageService.add({ severity: 'error', summary: 'Delete', detail: 'Data Deleted' });
          }
      },
      {
          icon: 'pi pi-upload',
          routerLink: ['/fileupload']
      },
      {
          icon: 'pi pi-external-link',
          target: '_blank',
          url: 'http://angular.io',
          style: { background: '#4CAF50', color: 'white' }
      }
  ];
    if(this.userId!=''){
    this.GetAll(this.userId)
   }
  


  }
}
